<template>
  <div class="page">
    <mobileHeader title="流转流程" rightType="scanCode"></mobileHeader>
    <div class="center">
      <GasCylinderInfo :bottleInfo="bottleInfo" />
      <div v-for="(item, index) in selectList" :key="index" class="select-item" @click="selectValue = index" :class="selectValue == index && 'select-item-act'">{{item.label}}</div>
      <van-field
        v-model="allowance"
        type="number"
        @input="numberInput"
        placeholder="请输入充装前的余量"
      />
    </div>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import GasCylinderInfo from "@/components/GasCylinderInfo";
import { Toast } from 'vant';
export default {
  data() {
    return {
      selectValue: 0,
      allowance: 0,
      selectList: [
        {
          label: "空瓶进站",
          value: 1
        },
        {
          label: "重瓶发出",
          value: 2
        },
        {
          label: "重瓶退回",
          value: 3
        }
      ]
    }
  },
  components: {
    mobileHeader,GasCylinderInfo
  },
  created() {
    
  },
  computed: {
    bottleInfo(){
      return this.$store.state.bottleInfo
    }
  },
  methods: {
    numberInput(){
      
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  background: #f7f7f7;
  height: auto;
  min-height: 100vh;
  width: 100vw;
  flex-direction: column;
  .center {
    flex-grow: 1;
    .select-item{
      background: #999999;
      width: 90vw;
      margin: 10px 0;
      margin-left: 5vw;
      line-height: 10vw;
      text-align: center;
      color: white;
    }
    .select-item-act{
      background: #3cd340;

    }
  }
}
</style>
